var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
      'u-flex u-flex-col u-full-height u-overflow-hidden',
      _vm.isShowreel ? 'is-homepage' : '',
      _vm.isVideo ? 'is-video' : ''
    ],attrs:{"id":"app"}},[_c('main',{staticClass:"u-bg-white",attrs:{"id":"main"}},[_c('div',{staticClass:"o-container"},[_c('Header'),_c('div',{staticClass:"o-page"},[_c('transition',{attrs:{"name":_vm.transition}},[_c('router-view')],1)],1)],1)]),_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{attrs:{"name":"modal"}})],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }